export default "skymp5-front/7fa5047a9aaac4e523b03448a9df7307.png";